import axiosIns from '@/libs/axios'
import utilsService from './utilsService'

const controller = 'QuestionarioSocio'

export default {
  async getAll(filter) {
    const cleanFilter = utilsService.cleanObject(filter)
    return axiosIns
      .get(`${controller}?${utilsService.getQueryParams(cleanFilter)}`)
      .then(res => res.data)
  },
  async getById(id) {
    return axiosIns.get(`${controller}/detalhes/${id}`).then(res => res.data)
  },
  async getByUserId(userId) {
    return axiosIns.get(`${controller}/${userId}`).then(res => res.data)
  },
  async create(obj) {
    return axiosIns.post(controller, obj).then(res => res.data)
  },
}
